export default __webpack_public_path__ + "static/ichi_logo_horizontal_light-403c7c3042add2fb922748afc3f83233.svg";